import { sortOptions } from '../../core/ui/utils/sorting';
import { Site, Brand } from '../../sections/client-management/entities';
import { entityToSortedSelectOptions } from './getSelectOptions';

/**
 * For a specified groupId, this function returns a list of all sites in the
 * group (multisite) that can be used to populate Select components.
 */
export function getSelectOptionsForMultiSites(groupId: string, sites: Site[], brands: Brand[]) {
  if (groupId) {
    const groupSites = entityToSortedSelectOptions<Site>(sites).filter(siteOption => {
      const site = sites.find(site => site.id === siteOption.value);
      const brand = brands.find(brand => brand.id === site.brandId);
      return brand?.groupId === groupId;
    });
    return groupSites.sort(sortOptions);
  } else {
    return [];
  }
}
